/* Imported libraries imports */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import map from 'lodash/map';
import keys from 'lodash/keys';

import { hideNotifRequested } from '../actions';
import { notifType } from '../constants';

export class Notification extends Component {
    closeMessage = id => {
        this.props.hideNotifRequested(id);
    };

    notificationContent = props => {
        const type = notifType.includes(props.type) ? props.type : null;
        const classes = classNames({ Notification: true }, type);

        let icon = '';
        switch (type) {
            case 'warning':
                icon = 'ipic_warning';
                break;
            case 'success':
                icon = 'ipic_info';
                break;
            default:
                icon = 'ipic_notification';
                break;
        }

        if (
            typeof props.content === 'object' &&
            keys(props.content).length >= 1
        ) {
            return (
                <div key={props.id.toString()} className={classes}>
                    <span className="title">
                        <span className={`${icon} notif-icon`} />
                        {props.title}
                    </span>
                    .
                    {map(props.content, (key, value) => {
                        return [
                            <span className="Notification-Body" key={1}>
                                {key}
                            </span>,
                        ];
                    })}
                </div>
            );
        } else {
            return (
                <div key={props.id.toString()} className={classes}>
                    <span className="title">
                        <span className={`${icon} notif-icon`} />
                        {props.title}
                    </span>
                    .<span className="Notification-Body">{props.content}</span>.
                </div>
            );
        }
    };

    createNotification = notification => {
        return this.notificationContent(notification);
    };

    render() {
        const items = this.props.notifications.map(notif =>
            this.createNotification(notif)
        );
        return <div>{items}</div>;
    }
}

export const mapStateToPtops = state => {
    return {
        notifications: state.sagaNotifications,
    };
};

export default connect(
    mapStateToPtops,
    {
        hideNotifRequested,
    }
)(Notification);



// WEBPACK FOOTER //
// ./src/middleware/notifications/components/Notification.js